<template>
  <v-card class="py-2">
    <v-row no-gutters align="center" class="py-1 justify-start">
      <v-col cols="auto" class="pl-5">
        <v-icon :color="doc.iconColor">
          {{ doc.icon }}
        </v-icon>
      </v-col>
      <v-col cols="auto" class="documentName" style="max-width: 60%">
        <v-tooltip bottom color="font">
          <template #activator="{ on }">
            <div v-on="on" class="text-truncate" style="max-width: 17vw">
              {{ doc.document_name }}
            </div>
          </template>
          {{ doc.document_name }}
        </v-tooltip>
      </v-col>
      <v-col cols="auto" class="pl-2 idText"> {{ doc.documentIdText }}</v-col>
      <v-spacer />
      <v-col cols="auto">
        <dots-menu @download="$emit('download', doc.document_id)" :items="dotsItems" font-size="19px"></dots-menu>
      </v-col>
    </v-row>
    <v-row no-gutters class="py-2">
      <v-col cols="auto" class="text-left px-5 idText"> {{ $i18n.t('menu.folder') }}</v-col>
      <v-col cols="auto" class="font-weight-medium">
        <v-tooltip bottom color="font">
          <template #activator="{ on }">
            <div v-on="on" class="text-truncate folderInfo" style="max-width: 13vw">
              {{ doc.folder_name }}
            </div>
          </template>
          {{ doc.folder_name }}
        </v-tooltip>
      </v-col>
      <v-col cols="auto" class="ml-2 idText"> {{ doc.folderIdText }}</v-col>
    </v-row>
    <v-row no-gutters class="py-2">
      <v-col cols="auto" class="text-left px-5 idText"> {{ $i18n.t('menu.added') }}</v-col>
      <v-col cols="auto" class="font-weight-medium folderInfo">{{ doc.addedText }}</v-col>
    </v-row>
  </v-card>
</template>

<script>
import DotsMenu from '@/components/DotsMenu';
export default {
  name: 'DocumentPreview',
  components: { DotsMenu },
  props: {
    doc: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    dotsItems: [{ name: 'download' }],
  }),
};
</script>

<style scoped lang="scss">
.idText {
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
}
.folderInfo {
  color: rgba(0, 0, 0, 0.7);
  font-size: 14px;
}
.documentName {
  font-weight: 500;
  font-size: 14px;
  padding-left: 8px;
  text-align: left;
}
</style>
